<template>
    <section>
        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
            <el-form :inline="true">
                <el-form-item>
                    <el-input v-model="filters.userId" placeholder="商家ID"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getProducts">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleAdd">新增</el-button>
                </el-form-item>
            </el-form>
        </el-col>


        <el-table :data="products" highlight-current-row border stripe v-loading="listLoading"
                  @selection-change="selsChange"
                  style="width: 100%;text-align: center">
            <el-table-column type="expand">
                <template slot-scope="props">
                    <el-row>
                        <el-col :span="8">
                            <el-form label-position="left" label-width="160px" class="demo-table-expand">
                                <el-form-item label="商品安装指导">
                                    <span>{{ props.row.installGuidance}}</span>
                                </el-form-item>
                                <el-form-item label="到店安装费用">
                                    <span>{{ props.row.installMoney | formatMoney}}</span>
                                </el-form-item>
                                <el-form-item label="工程师普通车型补贴">
                                    <span>{{ props.row.commonSubsidy | formatMoney}}</span>
                                </el-form-item>

                            </el-form>
                        </el-col>
                        <el-col :span="8">
                            <el-form label-position="left" label-width="160px" class="demo-table-expand">

                                <el-form-item label="荣康万家普通车型差价">
                                    <span>{{ props.row.commonProfit | formatMoney}}</span>
                                </el-form-item>
                                <el-form-item label="工程师高端车型补贴">
                                    <span>{{ props.row.seniorSubsidy | formatMoney}}</span>
                                </el-form-item>
                                <el-form-item label="荣康万家高端车型差价">
                                    <span>{{ props.row.seniorProfit | formatMoney}}</span>
                                </el-form-item>
                            </el-form>
                        </el-col>
                        <el-col :span="8">
                            <el-form label-position="left" label-width="160px" class="demo-table-expand">
                                <!--<el-form-item label="商品图片">
                                    <span>{{ props.row.productImages}}</span>
                                </el-form-item>-->
                                <el-form-item label="备注">
                                    <span>{{ props.row.remark}}</span>
                                </el-form-item>
                                <el-form-item label="技能标签">
                                    <span>{{ props.row.skillsDesc}}</span>
                                </el-form-item>
                            </el-form>
                        </el-col>
                    </el-row>
                </template>
            </el-table-column>
            <el-table-column prop="productId" label="商品ID">
            </el-table-column>
            <el-table-column prop="userId" label="商家ID">
            </el-table-column>
            <!--<el-table-column prop="productNO" label="商品货号">
            </el-table-column>-->
            <el-table-column prop="productName" label="商品名称">
            </el-table-column>
            <el-table-column prop="productType" label="商品类型" :formatter="formatProductType">
            </el-table-column>
            <el-table-column prop="state" label="商品状态" :formatter="formatState">
            </el-table-column>
            <el-table-column prop="productLevel" label="商品级别" :formatter="formatProductLevel">
            </el-table-column>

            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="primary" size="small" @click="edit(scope.$index, scope.row)">编辑</el-button>
                    <el-button type="danger" size="small" @click="del(scope.$index, scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="rowCount"
                           :total="total" style="float:right;">
            </el-pagination>
        </el-col>

        <!--编辑界面-->
        <el-dialog title="编辑" customClass="customWidth" v-model="editFormVisible" :close-on-click-modal="false">
            <el-form :model="editForm" label-width="200px" ref="editForm">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="商品名称" class="require" prop="productName">
                            <el-input v-model="editForm.productName" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <!--<el-col :span="12">
                        <el-form-item label="商品货号" class="require" prop="productNO">
                            <el-input v-model="editForm.productNO" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>-->
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="商品类型" class="require" prop="productType">
                            <el-select style="width:100%" filterable v-model="editForm.productType"
                                       placeholder="请选择商品类型">
                                <el-option
                                        v-for="item in productType"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>

                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="商品状态" class="require" prop="state">
                            <el-select style="width:100%" filterable v-model="editForm.state"
                                       placeholder="请选择商品状态">
                                <el-option
                                        v-for="item in state"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="商品级别" class="require" prop="productLevel">
                            <el-select style="width:100%" filterable v-model="editForm.productLevel"
                                       placeholder="请选择商品级别">
                                <el-option
                                        v-for="item in productLevel"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="商品安装指导" prop="installGuidance">
                            <el-input v-model="editForm.installGuidance" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="到店安装费用" class="require" prop="installMoney">
                            <el-input v-model="editForm.installMoney" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="工程师普通车型补贴" class="require" prop="commonSubsidy">
                            <el-input v-model="editForm.commonSubsidy" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="荣康万家普通车型差价" class="require" prop="commonProfit">
                            <el-input v-model="editForm.commonProfit" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="工程师高端车型补贴" class="require" prop="seniorSubsidy">
                            <el-input v-model="editForm.seniorSubsidy" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="荣康万家高端车型差价" class="require" prop="seniorProfit">
                            <el-input v-model="editForm.seniorProfit" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <!--<el-row>
                    <el-col :span="24">
                        <el-form-item label="商品图片" prop="productImages">
                            <el-input v-model="editForm.productImages" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>

                </el-row>-->
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="技能标签" prop="skills">
                            <el-transfer v-model="editForm.skills" :props="{key: 'no',label: 'label'}"
                                         :data="skills"></el-transfer>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="备注" prop="remark">
                            <el-input v-model="editForm.remark" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
            </div>
        </el-dialog>

        <!--新增界面-->
        <el-dialog title="新增" customClass="customWidth" v-model="addFormVisible" :close-on-click-modal="false">
            <el-form :model="addForm" label-width="200px" ref="addForm">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="商品名称" class="require" prop="productName">
                            <el-input v-model="addForm.productName" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <!--<el-col :span="12">
                        <el-form-item label="商品货号" class="require" prop="productNO">
                            <el-input v-model="addForm.productNO" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>-->
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="产品类型" class="require" prop="productType">
                            <el-select style="width:100%" filterable v-model="addForm.productType"
                                       placeholder="请选择产品类型">
                                <el-option
                                        v-for="item in productType"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>

                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="商品状态" class="require" prop="state">
                            <el-select style="width:100%" filterable v-model="addForm.state"
                                       placeholder="请选择商品状态">
                                <el-option
                                        v-for="item in state"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="商品级别" class="require" prop="productLevel">
                            <el-select style="width:100%" filterable v-model="addForm.productLevel"
                                       placeholder="请选择商品级别">
                                <el-option
                                        v-for="item in productLevel"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="商品安装指导" prop="installGuidance">
                            <el-input v-model="addForm.installGuidance" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="到店安装费用" class="require" prop="installMoney">
                            <el-input v-model="addForm.installMoney" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="工程师普通车型补贴" class="require" prop="commonSubsidy">
                            <el-input v-model="addForm.commonSubsidy" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="荣康万家普通车型差价" class="require" prop="commonProfit">
                            <el-input v-model="addForm.commonProfit" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="工程师高端车型补贴" class="require" prop="seniorSubsidy">
                            <el-input v-model="addForm.seniorSubsidy" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="荣康万家高端车型差价" class="require" prop="seniorProfit">
                            <el-input v-model="addForm.seniorProfit" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <!-- <el-row>
                     <el-col :span="24">
                         <el-form-item label="商品图片" prop="productImages">
                             <el-input v-model="addForm.productImages" auto-complete="off"></el-input>
                         </el-form-item>
                     </el-col>

                 </el-row>-->
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="技能标签" prop="skills">
                            <el-transfer v-model="addForm.skills" :props="{key: 'no',label: 'label'}"
                                         :data="skills"></el-transfer>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="备注" prop="remark">
                            <el-input v-model="addForm.remark" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
            </div>
        </el-dialog>

    </section>
</template>

<script>
    import util from '../../common/js/util'
    import NProgress from 'nprogress'
    import {requestPost} from '../../api/api';
    import {data} from "../../common/data";

    export default {
        data() {
            return {
                filters: {
                    userId: ''
                },

                products: [],
                total: 0,
                rowCount: 30,
                pageNO: 1,
                listLoading: false,
                sels: [],

                editFormVisible: false,
                editLoading: false,
                editForm: {
                    productId: '',
                    /* productNO: '',*/
                    productName: '',
                    productType: '',
                    //productImages: '',
                    state: '',
                    productLevel: '',
                    skills: [],
                    installGuidance: '',
                    installMoney: 0,
                    commonSubsidy: 0,
                    commonProfit: 0,
                    seniorSubsidy: 0,
                    seniorProfit: 0,
                    remark: ''

                },

                addFormVisible: false,
                addLoading: false,
                productType: data.productType,
                state: data.state,
                productLevel: data.productLevel,
                skills: [],
                addForm: {
                    userId: '',
                    /* productNO: '',*/
                    productName: '',
                    productType: '',
                    //productImages: '',
                    state: '',
                    productLevel: '',
                    skills: [],
                    installGuidance: '',
                    installMoney: 0,
                    commonSubsidy: 0,
                    commonProfit: 0,
                    seniorSubsidy: 0,
                    seniorProfit: 0,
                    remark: ''
                },


            }
        },
        filters: {
            formatMoney: function (value) {
                if (value)
                    return value / 100 + ' 元';
                else return '';
            },
        },
        methods: {


            formatProductType(row) {

                return data.productType[row.productType].label;
            },
            formatState(row) {

                return data.state[row.state].label;
            },
            formatProductLevel(row) {

                return data.productLevel[row.productLevel].label;
            },

            handleCurrentChange(val) {
                this.pageNO = val;
                this.getProducts();
            },

            getProducts() {

                let para = {
                    rowCount: this.rowCount,
                    pageNO: this.pageNO
                };
                para = Object.assign(para, this.filters);
                this.listLoading = true;
                NProgress.start();
                let url = 'product/queryPage.do';
                requestPost(this, url, para).then((res) => {

                    if (res != '') {
                        this.total = res.total;
                        this.products = res.data;
                    }
                    this.listLoading = false;
                    NProgress.done();
                });
            },
            //删除
            del: function (index, row) {
                this.$confirm('确认删除该记录吗?', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.listLoading = true;
                    NProgress.start();
                    let para = {productId: row.productId};
                    let url = 'product/del.do';
                    requestPost(this, url, para).then((res) => {
                        this.listLoading = false;
                        NProgress.done();
                        if (res != '') {
                            util.successTip(this);
                            this.getProducts();
                        }
                    });
                }).catch(() => {

                });
            },
            //显示编辑界面
            edit: function (index, row) {
                this.getSkills().then(() => {
                    this.editFormVisible = true;
                    this.editForm = Object.assign({}, row);
                    this.editForm.installMoney = row.installMoney / 100;
                    this.editForm.commonSubsidy = row.commonSubsidy / 100;
                    this.editForm.commonProfit = row.commonProfit / 100;
                    this.editForm.seniorSubsidy = row.seniorSubsidy / 100;
                    this.editForm.seniorProfit = row.seniorProfit / 100;
                    if (typeof row.skills !== 'undefined' && row.skills.length > 0)
                        this.editForm.skills = row.skills.split(',').map(Number);
                    else this.editForm.skills = [];
                });


            },

            //显示新增界面
            handleAdd: function () {
                if (this.filters.userId === '') {
                    this.$message({
                        message: '请在左侧输入框输入商家ID',
                        type: 'warning'
                    });
                } else {
                    this.getSkills().then(() => {
                        this.addFormVisible = true;
                    });
                }

            },

            getSkills() {
                let that = this;
                NProgress.start();
                let url = 'skill/getAll.do';
                return new Promise(function (resolve, rej) {
                    requestPost(this, url, {}).then((res) => {

                        NProgress.done();
                        if (res != '') {
                            that.skills = res.data;
                            resolve();
                        }

                    });
                })

            },
            //编辑
            editSubmit: function () {

                this.$confirm('确认提交吗？', '提示', {}).then(() => {
                    this.editLoading = true;
                    NProgress.start();
                    console.log(this.editForm.skills);
                    let para = Object.assign({}, this.editForm);
                    para.skills = this.editForm.skills.join(',');
                    para.installMoney = this.editForm.installMoney * 100;
                    para.commonSubsidy = this.editForm.commonSubsidy * 100;
                    para.commonProfit = this.editForm.commonProfit * 100;
                    para.seniorSubsidy = this.editForm.seniorSubsidy * 100;
                    para.seniorProfit = this.editForm.seniorProfit * 100;

                    let url = 'product/update.do';
                    requestPost(this, url, para).then((res) => {
                        this.editLoading = false;
                        NProgress.done();
                        if (res != '') {
                            util.successTip(this);
                            this.$refs['editForm'].resetFields();
                            this.editFormVisible = false;
                            this.getProducts();
                        }

                    });
                });

            },

            addSubmit: function () {

                this.$confirm('确认提交吗？', '提示', {}).then(() => {
                    this.addLoading = true;
                    NProgress.start();
                    let para = Object.assign({}, this.addForm);
                    para.skills = this.addForm.skills.join(',');
                    para.installMoney = this.addForm.installMoney * 100;
                    para.commonSubsidy = this.addForm.commonSubsidy * 100;
                    para.commonProfit = this.addForm.commonProfit * 100;
                    para.seniorSubsidy = this.addForm.seniorSubsidy * 100;
                    para.seniorProfit = this.addForm.seniorProfit * 100;
                    para.userId = this.filters.userId;

                    let url = 'product/add.do';
                    requestPost(this, url, para).then((res) => {
                        this.addLoading = false;
                        NProgress.done();
                        if (res !== '') {
                            util.successTip(this);
                            this.$refs['addForm'].resetFields();
                            this.addForm.skills = [];
                            this.addFormVisible = false;
                            this.getProducts();
                        }
                    });
                });

            },

            selsChange: function (sels) {
                this.sels = sels;
            }

        },
        mounted() {
            let query = this.$route.query;
            if (typeof query.userId !== 'undefined') {
                this.filters.userId = this.$route.query.userId;
            }
            this.getProducts();
        },
        activated: function () {

        }
    }

</script>


<style scope lang="scss" type="text/scss">
    @import '../../styles/vars.scss';
</style>


// WEBPACK FOOTER //
// productList.vue?9670d856